// import 'firebase/compat/auth';

import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from 'firebase/auth';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import {
  MenuController
} from '@ionic/angular';
// import firebase from 'firebase/compat/app';
// import { DbService } from 'src/app/services/db.service';
// import {NgxCaptchaModule,ReCaptcha2Component} from 'ngx-captcha';
// import * firebase from 'firebase';
// import 'firebase/auth';

@Component({
  selector: 'app-otp-login',
  templateUrl: './otp-login.component.html',
  styleUrls: ['./otp-login.component.scss'],
})
export class OtpLoginComponent implements OnInit {
  otp_form:any = FormGroup;
  otp_verify;
  verificationId;
  otp;
  shake;
  windowRef: any;
  otp_submit;
  mobile_no;
  
  @Input() check_out;
  @Input() number_for_checkout;

  constructor(private menuCtrl: MenuController,public menu: MenuService,private router: Router,private formbuilder:FormBuilder,public db:DataService) { }

  ngOnInit() {
    
    this.windowRef = this.db.windowRef;
    this.otp_form = this.formbuilder.group({
        mobile_no: ['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
        otp: ['',[Validators.required]]
      })

      // this.recaptchaverifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
      // this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
      // this.windowRef.recaptchaVerifier.render().then((widgetId) => {
      //   this.windowRef.recaptchaWidgetId = widgetId;
      // });
      
    // this.db.otp_send.subscribe(res =>{
    //   res == 'sent' ?( this.otp_verify = true ): null
    // })

    this.recaptcha();
  }


  recaptcha() {
    console.log('dsg')
    const auth = getAuth();
    
    // var recaptchaVerifier = new RecaptchaVerifier(
    //   "sign-in-button",
    //    {
    //     size: "invisible",
    //    },
    //      auth
    // );

    // recaptchaVerifier.render();

    this.windowRef.recaptchaVerifier = new RecaptchaVerifier('sign-in-button', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        console.log("recaptcha solved")
        // onSignInSubmit();
      },
      
    }, auth);
    this.windowRef.recaptchaVerifier.render();
  }


  get  otp_verifyy(){
    return this.otp_verify ? true : false;
  }
  

  get phonenumber() {
    return this.otp_form.get('mobile_no');
  }

  get otp_() {
    return this.otp_form.get('otp');
  }


  async sendLoginCode(){
    this.otp_submit = true;
    // console.log(this.otp_form.controls)

    if(this.otp_form.controls.mobile_no.status == 'VALID'){
      this.db.send_otp({mobile_no : this.mobile_no}).subscribe(res => {
                // console.log(res)
                this.otp_submit = false;
              if (res.message.status == 'Success') {
                this.verificationId = true
                setTimeout( ()=>{ this.otp_verify = true },250)
              } else {
                this.db.alert(res.message.message)
                // this.get_customer_info(res.message[0].user_id, true);
              }
            },error => { console.error(error)})
      // let prefi = "+91";
      // const num = prefi.toString() + this.mobile_no.toString();
      // const appVerifier = this.windowRef.recaptchaVerifier;
      
      //   setTimeout( ()=>{ this.otp_verify = true },250)


      //   const auth = getAuth();
      //   console.log(auth)
      //   signInWithPhoneNumber(auth, num, appVerifier)
      //       .then((confirmationResult) => {
      //         // SMS sent. Prompt user to type the code from the message, then sign the
      //         // user in with confirmationResult.confirm(code).
      //         // window.confirmationResult = confirmationResult;
      //         this.windowRef.confirmationResult = confirmationResult;
      //         this.verificationId = confirmationResult.verificationId;
      //         // console.log("otp send")
      //         // ...
      //       }).catch((error) => {
      //         console.log(error)
      //         if(error.code == 'auth/invalid-phone-number') {
      //           // this.mobile_error = true;
      //           // this.otp_submitted = false;
      //           this.db.alert("Invalid Phone Number")
      //         } else if(error.code == 'auth/too-many-requests') {
      //           // this.otp_submitted = false;
      //           // !this.db.cust_name ? this.db.alert(error.message) : null
      //         }
      //         // grecaptcha.reset(this.windowRef.recaptchaWidgetId);
      //         grecaptcha.reset();
      //         // grecaptcha.render('sign-in-button');
      //       });


      // firebase.auth().signInWithPhoneNumber(num, appVerifier).then(result=>{
      //       // console.log(result);
      //       // this.otp_verify = result;
      //       // this.db.otp_send.next('sent')
      //       this.verificationId = result.verificationId;
      //       // console.log(this.verificationId)
      //       // console.log(result);
      //     if(this.db.ismobile){
      //       // this.start_watch();
      //     }
      //   }).catch(err=>{ console.log(err)

      //     if(err.code == 'auth/invalid-phone-number') {
      //       // this.mobile_error = true;
      //       // this.otp_submitted = false;
      //       this.db.alert("Invalid Phone Number")
      //     } else if(err.code == 'auth/too-many-requests') {
      //       // this.otp_submitted = false;
      //       !this.db.cust_name ? this.db.alert(err.message) : null
      //     }
      //   });

    }else{
      this.shake = true;
      setTimeout( () => { this.shake = false },400)
    }

  }


  resend(){
    this.otp_form.controls.otp.setValue('');
    this.sendLoginCode();
  }



  verify_otp() {
    this.otp_submit = true;
    // console.log(this.otp_form.controls.otp)
    if(this.otp_form.controls.otp.status == 'VALID'){

       this.db.verify_otp({mobile_no : this.mobile_no,otp:this.otp}).subscribe(res => {
        // console.log(res)
      if (res.message.status == 'Success') {
        this.otp_submit = false;
          if(res.message.type == 'Vendor'){
            localStorage['domain_api_key'] = res['message'].api_key;
            localStorage['domain_api_secret'] = res['message'].api_secret;
            localStorage['business'] = res.message.business;
            localStorage['domain_customerId'] = res.message.email;
            localStorage['restaurant_name'] = res.message.full_name;
            this.db.cust_email = res.message.customer_email;
            this.db.restaurant_name = res.message.customer_name;
            this.db.login_info.restaurant_name = this.db.restaurant_name;
            this.db.cust_name = localStorage['restaurant_name'];
            // this.router.navigateByUrl('/');
            this.db.normal_login = true;
            this.menu.enable_pos_menu = true;
            this.menuCtrl.enable(true, 'profileMenu');
            this.menu.set_pos_menu();
            this.menu.get_business_settings();
            // this.menu.get_pos_all_products();
            this.db.get_profiles();
            this.router.navigateByUrl("/admin-dashboard");
            localStorage['adminRefId'] && localStorage['player_id'] && localStorage['player_id'] != "undefined" && localStorage['player_id'] != undefined ? this.db.update_onsignal_id().subscribe(res => { console.log("one signal id updated..", res) }) : null
          }
      } else {
        this.db.alert(res.message.message)
      }
    },error => { console.error(error)})

      // this.windowRef.confirmationResult.confirm(this.otp.toString()).then((result) => {
      //     // console.log("success",result)
      //     const user = result.user;
      //     this.otp_success();
      //   }).catch((error) => {
      //     // !this.db.cust_name ?  this.db.alert(error.code) : null
      //     // console.log("error",error)
      //   });

        // var credential = firebase.auth.PhoneAuthProvider.credential(confirmationResult.verificationId, code);
        // let signInCredential = firebase.auth.PhoneAuthProvider.credential(this.verificationId, this.otp.toString());
        // firebase.auth().signInWithCredential(signInCredential).then((info) => {
        //     this.otp_success();
        // }, error => { this.db.alert(error.code);  })
    } else{
      this.shake = true;
      setTimeout( () => { this.shake = false },400)
    }
  }




  otp_success(){
    this.db.customer_Info({phone : this.mobile_no}).subscribe(res => {
      // console.log("Get mobile number",res)
      if (res.message == undefined) {
            // if(this.db.ismobile){
            //   this.router.navigateByUrl('/register');
            // }else{otp_form.controls.
              // if(this.db.ismobile){
        //   this.router.navigateByUrl('/register');
        // }else{otp_form.controls.
        localStorage['otp_mobile'] = this.otp_form.controls.mobile_no.value
              // this.db.registerform = true;
            // }
      } else {
        this.get_customer_info(res.message[0].user_id, true);
      }
    },error => { console.error(error)})
  }

  get_customer_info(data, value) {
    // console.log(data);
    this.db.customer_Info({email:data}).subscribe(res => {
      // console.log(res)
      if (res.message) {
          // this.db.store_customer_info(res)
          // this.db.dismiss();
      } else {
        // if(this.db.ismobile){
          // this.router.navigateByUrl('/register');
          // this.get_customer_info(data, value)
        // }else{
          this.get_customer_info(data, value)
          // this.db.registerform = true;
        // }
          // this.router.navigateByUrl
      }
    },error => { this.db.alert('Check E-mail ID / Password'); console.error(error)})
  }


  get_country_list() {
    // this.db.get_country_list().subscribe((r: any) => {
      
    // }, error => { console.log(error)})
  }
  
}
